import { useEffect, useState } from 'react';
import { toDateKey } from '@skolveckan/shared';

/**
 * Klockan kommer från elevens egen enhet, aldrig från servern. Nu-linjen
 * flyttar sig en pixel i minuten — 30 sekunders intervall räcker för att det
 * ska kännas levande utan att rendera i onödan.
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);

  return now;
}

export function nowMinutes(now: Date): number {
  return now.getHours() * 60 + now.getMinutes();
}

export function todayKey(now: Date): string {
  return toDateKey(now);
}
